import React, { ReactNode } from "react";
import styles from "./third-split-container.module.scss";

interface ThirdSplitContainerPropTypes {
  children: ReactNode;
  alignCenter?: boolean;
  flexGrow?: boolean;
}

const cssClassName = "third-split-container";

export const ThirdSplitContainer = ({
  children,
  alignCenter,
  flexGrow,
}: ThirdSplitContainerPropTypes) => {
  const childArray = React.Children.toArray(children);
  const part = Math.ceil(childArray.length / 3);

  const firstPartChildren = childArray.slice(0, part);
  const secondPartChildren = childArray.slice(part, part * 2);
  const thirdPartChildren = childArray.slice(part * 2);

  const alignCenterOrNot = () => {
    return alignCenter ? styles[`${cssClassName}--align-center`] : "";
  };
  const growOrNot = (block = "") => {
    return flexGrow ? styles[`${cssClassName}${block}--flex-grow`] : "";
  };

  return (
    <div
      className={`${styles[cssClassName]} ${alignCenterOrNot()} ${growOrNot()}`}
    >
      <div
        className={`${styles[`${cssClassName}__first-group`]} ${growOrNot(
          "__first-group",
        )}`}
      >
        {firstPartChildren}
      </div>
      <div
        className={`${styles[`${cssClassName}__second-group`]} ${growOrNot(
          "__second-group",
        )}`}
      >
        {secondPartChildren}
      </div>
      <div
        className={`${styles[`${cssClassName}__third-group`]} ${growOrNot(
          "__third-group",
        )}`}
      >
        {thirdPartChildren}
      </div>
    </div>
  );
};
